<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yooXWW/tc-custom/9781614483052.jpg?1700958392610" alt="This image is the cover for the book It's Time for Joy!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">It's Time for Joy!
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Discover how to create a life of joy right now with this wonderful self-help guide.</b></p><p> The decision to embrace every day as a treasure is ultimately a choice of love over fear. In our rapidly accelerating world, it’s easy to lose sight of that pivotal choice. That’s why it’s never been so important to enjoy every precious moment. Now truly is the time for joy! </p><p> In his encouraging, easy-to-read style, popular inspirational author Brian Biro gives us the hope and heart of touching stories from his own life and the lives of men and women who have truly made an art of creating lasting joy. Isn’t it time you became the happiest person you know? </p><p><b>Praise for <i>It’s Time for Joy!</i></b></p><p><i> </i><b>“<i>It’s Time for Joy</i> provides a simple yet compelling message of hope, love, and personal responsibility. Brian Biro’s stories are powerful catalysts for reigniting one's passion for life.”—John Gray, author of <i>Men Are from Mars, Women Are from Venus</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian Biro
      </h2>
      
      <p class="authorDescription body article">Brian Biro is America's Breakthrough Coach! He is one of the nation's foremost speakers and teachers of Leadership, Possibility Thinking, Thriving on Change, and Team-Building. A major client described him best when he said, ""Brian Biro has the energy of a ten-year-old, the enthusiasm of a twenty-year-old, and the wisdom of a seventy-five-year-old."" A former vice-president of a major transportation corporation and the author of 8 books including bestseller, Beyond Success! which reached #71 on the Amazon.com top 100 - from over 2 million titles, Brian was rated #1 from over 40 Speakers at 4 consecutive INC. Magazine International Conferences. With degrees from Stanford University and UCLA, Brian has appeared on Good Morning America, CNN's Business Unusual, and the Fox News Network. He lives in Asheville, NC with his wife Carole and daughters Kelsey and Jenna.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?45f30700